export enum TransactionFlowEnum {
    /**Entrata */
    CashIn = 0,

    /**Uscita */
    CashOut = 1,

    /**Nullo */
    None = 2,
}

export function transactionFlowEnumLabel(val: TransactionFlowEnum): string {
    let res = "";
    switch (val) {
        case TransactionFlowEnum.CashIn:
            res = "enum.transaction_flow.cash_in";
            break;
        case TransactionFlowEnum.CashOut:
            res = "enum.transaction_flow.cash_out";
            break;
        case TransactionFlowEnum.None:
            res = "enum.transaction_flow.none";
            break;
        default:
            res = "common.unknown";
            break;
    }
    return res;
}
